import React, { useEffect, useState } from "react";
import { scrollToPricing } from "./shared";

export function StickyMobileCTA() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const f = () => setShow(window.scrollY > 700);
    window.addEventListener("scroll", f);
    return () => window.removeEventListener("scroll", f);
  }, []);
  return (
    <div className={`lg:hidden fixed bottom-0 inset-x-0 z-[60] transition-transform duration-300 ${show ? "translate-y-0" : "translate-y-full"}`}>
      <div className="bg-[#0A1530]/95 backdrop-blur-xl border-t border-white/10 px-4 py-3 flex items-center justify-between gap-3">
        <div>
          <div className="text-white font-display font-bold text-lg leading-none">$497 <span className="text-[#7C8FA8] text-xs line-through font-normal">$649</span></div>
          <div className="text-[10px] text-[#10B981] mt-1">30-day money-back guarantee</div>
        </div>
        <button onClick={scrollToPricing} data-testid="sticky-cta" className="px-6 py-3 rounded-full bg-gradient-to-r from-[#F59E0B] to-[#F97316] text-white font-bold text-sm uppercase tracking-wide shadow-[0_6px_20px_rgba(249,115,22,0.4)]">
          Get Access
        </button>
      </div>
    </div>
  );
}
